import React, { useState } from 'react';
import ProjectSidePanel from './components/ProjectSidePanel';
import Pagination from '../../components/ui/Pagination';
import ProjectFilters from './components/ProjectFilters';
import ProjectsTable from './components/ProjectsTable';
import { useProjects } from './hooks/useProjects';
import { useHighlight } from '../../hooks/useHighlight';

const ProjectsListPage: React.FC = () => {
  const [selectedProjectId, setSelectedProjectId] = useState<number | null>(null);
  const [openInEditMode, setOpenInEditMode] = useState(false);

  const {
    customers,
    selectedCustomer,
    setSelectedCustomer,
    data,
    loading,
    error,
    searchQuery,
    setSearchQuery,
    filteredProjects,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    totalPages,
    startIndex,
    endIndex,
    currentProjects,
    handlePageChange,
    load,
  } = useProjects();

  const { highlightedId } = useHighlight(data, 'data-project-id');

  return (
    <div className="max-w-full mx-auto theme-card rounded-2xl p-3 md:p-4">
      <h1 className="text-xl font-semibold mb-3 theme-text-primary">JobTRAC (All)</h1>

      {error && (
        <div className="mb-3 p-2 rounded bg-red-50 text-red-700 border border-red-200 text-sm">{error}</div>
      )}

      <ProjectFilters
        customers={customers}
        selectedCustomer={selectedCustomer}
        searchQuery={searchQuery}
        onCustomerChange={setSelectedCustomer}
        onRefresh={() => load()}
        onSearchChange={setSearchQuery}
      />

      <ProjectsTable
        currentProjects={currentProjects}
        highlightedId={highlightedId}
        loading={loading}
        searchQuery={searchQuery}
        onView={(id) => {
          setOpenInEditMode(false);
          setSelectedProjectId(id);
        }}
        onEdit={(id) => {
          setOpenInEditMode(true);
          setSelectedProjectId(id);
        }}
      />

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        itemsPerPage={itemsPerPage}
        startIndex={startIndex}
        endIndex={endIndex}
        total={filteredProjects.length}
        loading={loading}
        onPageChange={handlePageChange}
        onItemsPerPageChange={(perPage) => {
          setItemsPerPage(perPage);
          setCurrentPage(1);
        }}
      />

      {/* Side Panel */}
      {selectedProjectId && (
        <ProjectSidePanel
          projectId={selectedProjectId}
          onClose={() => {
            setSelectedProjectId(null);
            setOpenInEditMode(false);
          }}
          onUpdate={() => load()}
          initialEditMode={openInEditMode}
        />
      )}
    </div>
  );
};

export default ProjectsListPage;
